import Loadable from 'react-loadable';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const ViewJobPageLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ViewJobPage" */
      './ViewJobPage.dynamic'
    ),
  loading: LoadingPageLoadable,
});
